export const APP_URLS = {
    routes: {
        main: '/',
        confirmEmail: '/email-confirm',
        transactions: '/transactions',
        referrals: '/referrals',
        leader_board: '/leader-board',
        hardware: '/hardware',
        profile: '/profile',
        item_4: '/item_4'
    }
}

export const API_URLS = {
    confirmEmail: '/email-confirm/client',
    personalInfoUser: '/client/info',
    sendConfirmationLink: '/client/send-confirmation',
    signOut: '/sign-out/client',
    getPaymentFormData: '/client/payment/form',
    getHardwareFormData: '/client/hardware/form',
    getHardwareDashboard: '/client/hardware',
    referralsList: '/client/ref-list',
    paymentsList: '/client/payment/list',
    hardwarePaymentsList: '/client/hardware/payments-list',
    balances: '/client/payment/balance',
    createDirectPayment: '/client/payment/create-direct',
    createHardwareDirectPayment: '/client/hardware/create-direct',
    updateDirectPayment: '/client/payment/update-direct',
    updateHardwareDirectPayment: '/client/hardware/update-direct',
    createPaymentRequest: '/client/payment/create',
    createHardwarePaymentPSPRequest: '/client/hardware/create',
    dashboard: {
        topHolders: '/client/top-clients',
        dashboard: "/client/dashboard",
        presale: "/statistic"
    },
    options: {
        currencies: '/client/currencies',
        transactionsOptions: '/client/constants',
    },
    wsRates: '/ws/rates',
    nonce: '/nonce/client',
    user: {
        get_user: '/client/get-info'
    },
    games: {
        list: '/client/game/list',
        game: '/client/game'
    }
}

export const buildAPIUrl = url => {
    if (process.env.NODE_ENV === "development") {
        return url
    } else {
        return process.env.REACT_APP_NODE_HTTP_HOST + url
    }
};
export const buildWSUrl = url => {
    if (process.env.NODE_ENV === "development") {
        return process.env.REACT_APP_NODE_WSS_HOST + url
    } else {
        return process.env.REACT_APP_NODE_WSS_HOST + url
    }
};